import { Component } from "react";
import { useTranslation } from "../translations/LanguageContext";

// React error boundaries must be class components - no hook equivalent exists.
class ErrorBoundaryClass extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error(error, info);
    }

    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
}

// Wraps the class component so the fallback UI can use translations/hooks.
export function ErrorBoundary({ children }) {
    const { t } = useTranslation();
    const fallback = (
        <div className="error-banner" role="alert">
            <p>{t("common.errors.unexpected")}</p>
            <button className="secondary-btn" onClick={() => window.location.reload()}>
                {t("common.reload")}
            </button>
        </div>
    );
    return <ErrorBoundaryClass fallback={fallback}>{children}</ErrorBoundaryClass>;
}
